package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card_detail.LoyaltyCardDetail
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle

@Composable
fun Balance(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    setIsPointsActiveStatus: (Boolean) -> Unit,
    setCardLimit: (Int) -> Unit,
    setDailyLimit: (Int) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
)
{
    Column(
        modifier = Modifier
            .margin(bottom = Dimen.extraLargePadding)
    )
    {
        MediumContentTitle(
            title = Strings.current().balance,
        )

        if (windowSizeMode== WindowSizeModeEnum.Desktop)
        {
            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {
                Content(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    setCardLimit={
                        setCardLimit(it)
                    },
                    setDailyLimit={
                        setDailyLimit(it)
                    },
                    setIsPointsActiveStatus={
                        setIsPointsActiveStatus(it)
                    }
                )
            }
        }else{
            Column() {
                Content(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    setCardLimit={
                        setCardLimit(it)
                    },
                    setDailyLimit={
                        setDailyLimit(it)
                    },
                    setIsPointsActiveStatus={
                        setIsPointsActiveStatus(it)
                    }
                )
            }
        }





    }



}

@Composable
private fun Content(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    setCardLimit: (Int) -> Unit,
    setDailyLimit: (Int) -> Unit,
    setIsPointsActiveStatus: (Boolean) -> Unit
) {
    Row()
    {
        CustomEditText(
            modifier = Modifier,
            label = Strings.current().balance,
            isEnabled = false,
            value = selectedLoyaltyCard?.balance?.toString() ?: "",
            marginRight = Dimen.largePadding,
            textAlign = TextAlign.End,
            marginBottom = Dimen.smallPadding,
            width = Dimen.highNormalEditTextWidth,
            isRequired = false,
            hint = "",
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->

            },
        )


        CustomEditText(
            modifier = Modifier,
            isEnabled = false,
            label = Strings.current().points,
            value = formatNumberWithCommas(
                selectedLoyaltyCard?.points
            ),
            width = Dimen.highNormalEditTextWidth,
            marginRight = Dimen.largePadding,
            textAlign = TextAlign.End,
            isRequired = false,
            hint = "",
            marginBottom = Dimen.smallPadding,
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->

            },
        )
    }
    Row()
    {
        CustomEditText(
            modifier = Modifier,
            label = Strings.current().cardLimit,
            marginRight = Dimen.largePadding,
            width = Dimen.highNormalEditTextWidth,
            value = selectedLoyaltyCard?.limit?.toString() ?: "",
            isRequired = false,
            isDecimal = true,
            hint = "",
            marginBottom = Dimen.smallPadding,
            onFocusIn = { },
            onFocusOut = {
                setCardLimit(it.toInt())
            },
            onInputChange = {it, validation ->

            },
        )


        CustomEditText(
            modifier = Modifier,
            label = Strings.current().dailyLimit,
            marginRight = Dimen.largePadding,
            value = selectedLoyaltyCard?.dayLimit?.toString() ?: "",
            width = Dimen.highNormalEditTextWidth,
            isRequired = false,
            isDecimal = true,
            hint = "",
            marginBottom = Dimen.smallPadding,
            onFocusIn = {},
            onFocusOut = {
                setDailyLimit(it.toInt())
            },
            onInputChange = {it, validation ->

            },
        )
    }


    CheckboxComponent(
        modifier = Modifier,
        checkStatus = selectedLoyaltyCard?.isPointsActive ?: false,
        title = Strings.current().activate,
        onChecked = {
            setIsPointsActiveStatus(true)
        },
        onUnChecked = {
            setIsPointsActiveStatus(false)
        },
    )
}

fun formatNumberWithCommas(number: Int?): String {
        if (number==null)
            return ""
    return number.asDynamic().toLocaleString()
}